/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
import Vue from 'vue'

export function getToken(token_name) {
  let keys = Object.keys(localStorage)
  let TokenKey = keys.find(el => el.includes(`.${token_name}`))
  return {
    token: TokenKey ? localStorage.getItem(TokenKey) : null,
    tokenKey: TokenKey || null
  }
}

export const isUserLoggedIn = async function () {
  try {
    const accessTokenInfo = getToken('accessToken')
    const refreshTokenInfo = getToken('refreshToken')
    const idTokenInfo = getToken("idToken")

    if (accessTokenInfo.token === null || refreshTokenInfo.token === null || idTokenInfo.token === null){
      return false
    }

    const response = await Vue.prototype.$http.post('global/security/tokencheck', {
      accessToken: accessTokenInfo.token,
      refreshToken: refreshTokenInfo.token
    })

    const authInfo = response.data

    if (authInfo.authorized === false){
      return false
    }

    if (authInfo.isRefreshed){
      localStorage.setItem(accessTokenInfo.tokenKey, authInfo.accessToken)
      localStorage.setItem(refreshTokenInfo.tokenKey, authInfo.refreshToken)
      localStorage.setItem(idTokenInfo.tokenKey, authInfo.idToken)
    }
    return true
  } catch {
    return false
  }
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
/*
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return '/'
  if (userRole === 'client') return { name: 'access-control' }
  return { name: 'auth-login' }
}
*/

export const getHomeRouteForLoggedInUser = a => '/'

export const isAuthorizatedPage2 = async pageName => Vue.prototype.$http.get('global/auth', {
  params: {
    page_name: pageName,
  },
}).then(({ data }) => data.pageAuthorization)

export const isAuthorizatedPage = async pageName => {
  if (pageName === 'global-homePage') {
    return true
  }
  let isAuthorized = false;
  await Vue.prototype.$http.get('global/authv2', {
    params: {
      page_name: pageName,
    },
  }).then(({ data }) => isAuthorized = data.pageAuthorization)
  .catch(err =>  isAuthorized = false)
  console.log("🚀 ~ isAuthorized:", isAuthorized)
  return isAuthorized
}


export const checkApproved = async () => {
  if (sessionStorage.getItem('consentApproved') === 'true') {
    return true;
  }
  try {
    const response = await Vue.prototype.$http.get('global/consent/check');
    sessionStorage.setItem('consentApproved', 'true');
    return response.status === 200;
  } catch (error) {
    sessionStorage.setItem('consentApproved', 'false');
    return false;
  }
};

export const checkOnboarding = async () => {
  try {
    console.log("checkOnboarding")
    const response = await Vue.prototype.$http.get('onboarding/customer/check_status', {
      validateStatus: function (status) {
        return status < 500; 
      }
    });

    if (response.status === 200) {
      return {
        status: true,
        isCompleted: response.data.payload?.isCompleted || false,
        isWaitingForEtl: response.data.payload?.isWaitingForEtl || false
      };
    } else if (response.status === 403) {
      return {
        status: false,
        isCompleted: false,
        isWaitingForEtl: false
      };
    } else {
      return {
        status: false,
        isCompleted: false,
        isWaitingForEtl: false
      };
    }
  } catch (error) {
    return {
      status: false,
      isCompleted: false,
      isWaitingForEtl: false
    };
  }
};
